var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSocialFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 77 145",
    "aria-labelledby": "facebookIcon facebookDesc"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.3 78.2l3.6-25.4H49.6V36.5c-.8-3.6.3-7.2 2.9-9.7 2.6-2.6 6.3-3.6 9.8-2.8h13.5V1C69.1.3 62.4 0 55.7 0c-9-.4-17.8 3.1-24 9.6-6.3 6.5-9.4 15.3-8.7 24.3v18.9H.9v25.4H23V144h26.6V78.2h21.7z"
  })));
}

export default SvgIconSocialFacebook;